import React from 'react'
import { observer } from 'mobx-react-lite'
import VersionsTable from './../components/VersionsTable.component'
import LoadingSpinner from './../../../components/shared/LoadingSpinner.component'
import Store from './../store'
import {
  MDBBtn,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBCollapse,
} from 'mdb-react-ui-kit'

import './ChangeLogModal.component.scss'

const ChangeLogModal = ({ isOpen, onResolve, onReject }) => {
  return (
    <MDBModal open={isOpen} tabIndex='-1' onClose={onReject} id='ChangeLogModalComponent'>
      <MDBModalDialog size='lg'>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>USABG Tech Releases, Tips & Tricks</MDBModalTitle>
            <MDBBtn type='button' className='btn-close' color='none' onClick={onReject}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody className={Store.isLoading ? 'is-loading' : ''}>
            <div className='loading-wrapper'>
              <LoadingSpinner size='md' isActive={true} />
            </div>
            <MDBCollapse open={!Store.isLoading} className='content-modal-wrapper'>
              <VersionsTable />
              {Store.safetyNet === true ? (
                <MDBBtn type='button' color='default' block onClick={onResolve} className='btn safety-net-btn'>
                  Log me out & download latest version!
                </MDBBtn>
              ) : (
                <MDBBtn type='button' color='default' block onClick={onReject} className='btn btn-info'>
                  OK
                </MDBBtn>
              )}
            </MDBCollapse>
          </MDBModalBody>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  )
}

export default observer(ChangeLogModal)
